import styled from 'styled-components';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
  min-width: 100%;

  justify-content: space-between;


  @media (max-width: 1092px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const StyledImg = styled.img`
  display: block;
  width: 80px;
  height: 80px;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  font-size: 46px;
  padding-bottom: 6.5px;

  @media (max-width: 640px) {
    font-size: 60px;
    width: 80px;
    height: 80px;
  }
`;

const BoxWrapper = styled.div`
 width: 100%;
`;

const TextWrapper = styled.div`
  max-width: 100%;
  padding-top: 12px;
  text-align: center;
`;

const ConstructionWrapper = styled.div`
  padding: 24px 34px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center
;

  @media (max-width: 640px) {
    padding: 9px;
  }

`;

const IIConWrapper = styled.div`
  padding: 24px 24px 15px 24px;

  @media (max-width: 640px) {
    padding: 9px;
  }
`;

export {
  IIConWrapper,
  Wrapper,
  StyledImg,
  BoxWrapper,
  TextWrapper,
  IconWrapper,
  ConstructionWrapper
};
